export const GET_MEDIA_GALLERY = "GET_MEDIA_GALLERY"
export const GET_MEDIA_GALLERY_SUCCESS = "GET_MEDIA_GALLERY_SUCCESS"
export const GET_MEDIA_GALLERY_FAILED = "GET_MEDIA_GALLERY_FAILED"

export const GET_MEDIA_GALLERY_USERS = "GET_MEDIA_GALLERY_USERS"
export const GET_MEDIA_GALLERY_USERS_SUCCESS = "GET_MEDIA_GALLERY_USERS_SUCCESS"
export const GET_MEDIA_GALLERY_USERS_FAILED = "GET_MEDIA_GALLERY_USERS_FAILED"

export const GET_SURVEY = "GET_SURVEY"
export const GET_SURVEY_SUCCESS = "GET_SURVEY_SUCCESS"
export const GET_SURVEY_FAILED = "GET_SURVEY_FAILED"

export const GET_MEDIA_GALLERY_DESIGN = "GET_MEDIA_GALLERY_DESIGN"
export const GET_MEDIA_GALLERY_DESIGN_SUCCESS =
  "GET_MEDIA_GALLERY_DESIGN_SUCCESS"
export const GET_MEDIA_GALLERY_DESIGN_FAILED = "GET_MEDIA_GALLERY_DESIGN_FAILED"

export const UPDATE_MEDIA_GALLERY_DESIGN = "UPDATE_MEDIA_GALLERY_DESIGN"
export const UPDATE_MEDIA_GALLERY_DESIGN_SUCCESS =
  "UPDATE_MEDIA_GALLERY_DESIGN_SUCCESS"
export const UPDATE_MEDIA_GALLERY_DESIGN_FAILED =
  "UPDATE_MEDIA_GALLERY_DESIGN_FAILED"

export const DELETE_MEDIA_GALLERY_ITEM = "DELETE_MEDIA_GALLERY_ITEM"
export const DELETE_MEDIA_GALLERY_ITEM_SUCCESS =
  "DELETE_MEDIA_GALLERY_ITEM_SUCCESS"
export const DELETE_MEDIA_GALLERY_ITEM_FAILED =
  "DELETE_MEDIA_GALLERY_ITEM_FAILED"

export const RESET_MEDIA_GALLERY = "RESET_MEDIA_GALLERY"

export const GET_LANDING_GALLERY = "GET_LANDING_GALLERY"
export const GET_LANDING_GALLERY_SUCCESS = "GET_LANDING_GALLERY_SUCCESS"
export const GET_LANDING_GALLERY_FAILED = "GET_LANDING_GALLERY_FAILED"

export const GET_MEDIA_GALLERY_LIST = "GET_MEDIA_GALLERY_LIST"
export const GET_MEDIA_GALLERY_LIST_SUCCESS = "GET_MEDIA_GALLERY_LIST_SUCCESS"
export const GET_MEDIA_GALLERY_LIST_FAILED = "GET_MEDIA_GALLERY_LIST_FAILED"
export const RESET_MEDIA_GALLERY_LIST = "RESET_MEDIA_GALLERY_LIST"

export const UPLOAD_EVENT_MEDIA = "UPLOAD_EVENT_MEDIA"
export const UPLOAD_EVENT_MEDIA_SUCCESS = "UPLOAD_EVENT_MEDIA_SUCCESS"
export const UPLOAD_EVENT_MEDIA_FAILED = "UPLOAD_EVENT_MEDIA_FAILED"

export const UPLOAD_LANDING_MEDIA = "UPLOAD_LANDING_MEDIA"
export const UPLOAD_LANDING_MEDIA_SUCCESS = "UPLOAD_LANDING_MEDIA_SUCCESS"
export const UPLOAD_LANDING_MEDIA_FAILED = "UPLOAD_LANDING_MEDIA_FAILED"

export const DELETE_LANDING_MEDIA = "DELETE_LANDING_MEDIA"
export const DELETE_LANDING_MEDIA_SUCCESS = "DELETE_LANDING_MEDIA_SUCCESS"
export const DELETE_LANDING_MEDIA_FAILED = "DELETE_LANDING_MEDIA_FAILED"

export const UPDATE_MEDIA_CAPTION = "UPDATE_MEDIA_CAPTION"
export const UPDATE_MEDIA_CAPTION_SUCCESS = "UPDATE_MEDIA_CAPTION_SUCCESS"
export const UPDATE_MEDIA_CAPTION_FAILED = "UPDATE_MEDIA_CAPTION_FAILED"

export const GET_FLAGGED_MEDIA = "GET_FLAGGED_MEDIA"
export const GET_FLAGGED_MEDIA_SUCCESS = "GET_FLAGGED_MEDIA_SUCCESS"
export const GET_FLAGGED_MEDIA_FAILED = "GET_FLAGGED_MEDIA_FAILED"
export const RESET_FLAGGED_MEDIA = "RESET_FLAGGED_MEDIA"

export const DELETE_MEDIA_REPORT = "DELETE_MEDIA_REPORT"
export const DELETE_MEDIA_REPORT_SUCCESS = "DELETE_MEDIA_REPORT_SUCCESS"
export const DELETE_MEDIA_REPORT_FAILED = "DELETE_MEDIA_REPORT_FAILED"
